import classes from './not-found.module.css';

const NotFound = () => {
    return (
        <section className={classes.section}>
            <div className={classes.inner}>
                <p className="eyebrow">404</p>
                <h1 className={classes.title}>
                    This page isn't
                    <br />
                    <em>here.</em>
                </h1>
                <p className={classes.body}>
                    The link may be out of date. Everything about PrepAnywhere and our three
                    products lives on one page now.
                </p>
                <a className={classes.cta} href="/">
                    Back to PrepAnywhere
                </a>
            </div>
        </section>
    );
};

export default NotFound;
